import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from '@/shared/ui';

import styles from './AiBasisQuote.module.scss';

type Props = {
  // The words of the transcript the value was read from.
  quote: string;
  // The words the clinician said for the value, when AI kept them.
  said?: string;
  className?: string;
};

// What an AI value rests on, after the value: "← “quote”", quiet and cut to
// one short line; the full text shows in a tooltip on hover and focus.
export const AiBasisQuote: FC<Props> = ({ quote, said, className }) => {
  const { formatMessage } = useIntl();

  if (!quote) {
    return null;
  }
  const text = said
    ? formatMessage(
        {
          id: 'workspace.note.aiBasisSaidQuote',
          defaultMessage: '← {said} · “{quote}”',
        },
        { said, quote },
      )
    : formatMessage(
        {
          id: 'workspace.note.aiBasisQuote',
          defaultMessage: '← “{quote}”',
        },
        { quote },
      );

  return (
    <Tooltip.Primary
      content={text}
      triggerClassName={cn(styles.trigger, className)}
    >
      <span
        className={cn('p3', styles.quote)}
        tabIndex={0}
        data-component="workspace-note-ai-quote"
      >
        {text}
      </span>
    </Tooltip.Primary>
  );
};
